
import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import {
  FormControl,
  FormGroup,
  ValidationErrors,
  Validators,
} from "@angular/forms";

import { ReportsService } from "../reports.service";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import notify from "devextreme/ui/notify";

import { DxReportViewerComponent } from "devexpress-reporting-angular";
import { environment } from "src/environments/environment";
import { Router, UrlSerializer } from "@angular/router";

@Component({
  selector: "app-generate-report",
  templateUrl: "./generate-report.component.html",
  styleUrls: ["./generate-report.component.scss"],
})
export class GenerateReportComponent implements OnInit, OnDestroy {
  loading: boolean;
  reportForm: FormGroup;
  @ViewChild("saveSwal") private saveSwal: SwalComponent;
  @ViewChild(DxReportViewerComponent, { static: false })
  viewer!: DxReportViewerComponent;
  title = "DXReportViewerSample";
  reportUrl = "";
  hostUrl: string = environment.reportBaseUrl;
  invokeAction: string = environment.reportActionUrl;

  constructor(
    private reportsService: ReportsService,
    private router: Router,
    private serializer: UrlSerializer
  ) {}

  ngOnInit() {
    this.reportFormInitialize();
  }

  /**
   * @name coaFormInitialize
   * @param
   * @returns
   * @description initializes FOC form
   */
  reportFormInitialize() {
    this.reportForm = new FormGroup({
      recordNo: new FormControl(null, [Validators.required]),
      companyId:  new FormControl(JSON.parse(localStorage.getItem("selectedCustomerBranch")).companyId, [])
    });
  }

  

  /**
   * @name getFormValidationErrors
   * @param {FormGroup} form
   * @return required validation
   */

  getFormValidationErrors(form: FormGroup) {
    const result = [];
    Object.keys(form.controls).forEach((key) => {
      //.replace(/([a-z0-9])([A-Z])/g, '$1 $2')
      const controlErrors: ValidationErrors = form.get(key).errors;
      if (controlErrors) {
        Object.keys(controlErrors).forEach((keyError) => {
          result.push({
            control: key.replace(/([a-z0-9])([A-Z])/g, "$1 $2"),
            error: keyError,
            value: controlErrors[keyError],
          });
        });
      }
    });
    return result;
  }

  
 

  /**
   * @name submitData
   * @param
   * @returns  submitData
   */
  submitData(reportForm?: FormGroup) {
    this.loading = true;
    let payload: any = {};
    payload = this.reportForm.value;
    const tree = this.router.createUrlTree([], { queryParams: payload });
    let parameters = this.serializer.serialize(tree);
    this.reportUrl =  "LensCard?" + parameters.split("?")[1];
    this.loading = false;
  }

  ngOnDestroy(): void {
    
  }
}
